import * as React from 'react';
import { useSelector } from 'react-redux';

import { IState } from '../../../store';
import { ISimilarState } from '../../../store/similar';
import { IAbUseExperiment } from '../../../types/abUseExperiments';
import { IOfferData } from '../../../types/offerData';
import { scrollToElement } from '../../../utils/navigation';
import { SimilarOffersBanner } from '../../../components/similar_offers/SimilarOffersBanner';
import { itemBasedOffersVisible } from '../../../utils/similarOffersVisible';
import {
  EBannerSimilarOffersExperiment,
  getBannerSimilarOffersExperiment,
} from '../../../utils/bannerSimilarOffersExperiment';
import { getUserEBC } from '../../../utils/tracking/get_user_ebc';
import { getPageEBC } from '../../../utils/tracking/get_page_ebc';

import * as Analytics from '../../../ebc/track_similar';

export const SimilarOffersBannerContainer: React.FC = () => {
  const similarOffers = useSelector<IState, ISimilarState>(state => state.similarOffers);
  const abUseExperiments = useSelector<IState, IAbUseExperiment[]>(state => state.abUseExperiments);
  const offerData = useSelector<IState, IOfferData>(state => state.offerData);
  const abGroup = useSelector<IState, number>(state => state.abGroup);

  const user = getUserEBC(offerData.user, abGroup);
  const page = getPageEBC(offerData.offer.id, offerData.breadcrumbs);

  const bannerSimilarOffersVariation = getBannerSimilarOffersExperiment(abUseExperiments);

  const handleViewSimilarOffers = React.useCallback(() => {
    Analytics.trackBannerClick({ page, user });

    if (bannerSimilarOffersVariation === EBannerSimilarOffersExperiment.B) {
      const similarOffersElement = document.getElementById('similarOffers');

      if (similarOffersElement) {
        scrollToElement(similarOffersElement);
      }
    }
  }, [page, user, bannerSimilarOffersVariation]);

  const handleBannerViewed = React.useCallback(() => {
    Analytics.trackBannerShow({ page, user });
  }, [page, user]);

  if (bannerSimilarOffersVariation === EBannerSimilarOffersExperiment.A || !itemBasedOffersVisible(similarOffers)) {
    return null;
  }

  return <SimilarOffersBanner onViewSimilarOffers={handleViewSimilarOffers} onBannerViewed={handleBannerViewed} />;
};

SimilarOffersBannerContainer.displayName = 'SimilarOffersBannerContainer';
